import React from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import "./Assets/fonts/Brusher-Regular.ttf";
import Home from "./Screens/Home/index";
import THome from "./Screens/TeacherHome";
import Courses from "./Screens/Courses";
import TCourses from "./Screens/TeacherCourses";
import Lessons from "./Screens/Courses/Lessons";
import Profile from "./Screens/Profile";
import ProfileDetails from "./Screens/Profile/ProfileDetails";
import ChangePassword from "./Screens/Profile/ChangePassword";
import AboutUs from "./Screens/Profile/About Us";
import HomeWork from "./Screens/HomeWork";
import Payments from "./Screens/Payments";
import FeePayment from "./Screens/Payments/FeePayment";
import Events from "./Screens/Events";
import Login from "./Screens/Login";
import PrivateRoute from "../services/privateRoute";
import Timetable from "./Screens/Timetable";
import TeacherTimetable from "./Screens/TeacherTimeTable";
import Footer from "./Components/MainLayout/Footer";
import Gallery from "./Screens/Gallery";
import Notification from "./Screens/Notifications";
import TNotification from "./Screens/TeacherNotification";
import { connect } from "react-redux";
import ForgotPassword from "./Screens/Login/ForgotPassword";
import Attendance from "./Screens/Attendance/index";
import MarkAtt from "./Screens/Attendance/MarkAtt";
import Holidays from "./Screens/Holidays";
import ViewAtt from "./Screens/Attendance/ViewAtt";
import AttStudent from "./Screens/AttStudent";
import AttStaff from "./Screens/AttStaff";
import Previous from "./Screens/Complaints/Previous";
import New from "./Screens/Complaints/New";
import AboutSchool from "./Screens/AboutSchool";
import Birthday from "./Screens/Birthday";
import AllComplaints from "./Screens/AllComplaints";
import Dashboard from "./Screens/Dashboard";
import MainDashboard from "./Screens/DashboardMain";
import Downloads from "./Screens/Downloads";
import Failure from "./Screens/Failure";
import ThankYou from "./Screens/ThankYou";
import Results from "./Screens/Results";
import ExamScheduleDetails from "./Screens/ExamSchedule";
import ExamSchedule from "./Screens/ExamSchedule/previous";
import AddMarks from "./Screens/AddMarks";
import AddMarksType from "./Screens/AddMarks/next";
import AddMarksComponent from "./Components/AddMarks";
import PreviousLeave from "./Screens/Leave/PreviousLeave";
import NewLeave from "./Screens/Leave/NewLeave";
import LiveClass from "./Screens/LiveClass";
import OnlineClass from "./Screens/OnlineClass";
import AddOnlineClass from "./Screens/AddOnlineMeeting";
import AttSummary from "./Screens/AttSummary";
import GroupSMS from "./Screens/SmsGroup/Group/index";
import ClassSMS from "./Screens/SmsGroup/Class/index";
import TermWise from "./Screens/FeeStatistics/TermWise/index";
import ClassWise from "./Screens/FeeStatistics/ClassWise";
import UploadHomeWork from "./Screens/HomeWorkUpload/UploadHomeWork";
import AssignedHomeWork from "./Screens/HomeWorkUpload/AssignedHomeWork";
import ExamQuestions from "./Screens/ExamQuestions";
import HomeV2 from "./version2/Pages/Home";
import ProfileV2 from "./version2/Pages/Profile";
import FooterV2 from "./version2/Layout/Footer";
import profilepic from "./version2/Pages/Home/profilepic";
import TeacherHomeV2 from "./version2/Pages/TeacherHome";
import TeacherProfile from "./version2/Pages/TeacherProfile";
import SMSTemplate from "./version2/Pages/SMSTemplate";
import StudentSms from "./version2/Pages/StudentSMS";
import StaffSMS from "./version2/Pages/StaffSMS";
import NumberSMS from "./version2/Pages/NumberSMS";
import LoginV2 from "./version2/Pages/Login";
import Attendancep from "./Screens/Attendance/AttPrinc";
// import LiveBusStatus from "./Screens/BusTrack/LiveBusStatus";
import AddMarksForStudents from "./Components/AddMarks/AddMarksForStudents";
import PublicFeePayment from "./Screens/Payments/FeePaymentViaAdmissionNo";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});
const App = (props) => {
  const { history, user } = props;
  const { pathname } = window.location.href;
  return (
    <div className="App" style={{ backgroundColor: "#ffffff" }}>
      <Router history={history}>
        {user.id ? <div style={{ height: 72 }} /> : null}
        <Switch>
          <PrivateRoute path="/" exact component={HomeV2} />
          <PrivateRoute path="/home" exact component={HomeV2} />
          <PrivateRoute path="/teacherHomeV2" exact component={TeacherHomeV2} />
          {/* <PrivateRoute path="/teacherhome" exact component={THome} /> */}
          <PrivateRoute path="/courses" exact component={Courses} />
          <PrivateRoute path="/lessons" exact component={Lessons} />
          <PrivateRoute path="/lessons/:Id" exact="true" component={Lessons} />
          <PrivateRoute path="/tcourses" exact component={TCourses} />
          <PrivateRoute path="/profile" exact component={ProfileV2} />
          <PrivateRoute
            path="/teacherProfile"
            exact
            component={TeacherProfile}
          />
          <PrivateRoute path="/profilePic" exact component={profilepic} />
          <PrivateRoute
            path="/profileDetails"
            exact
            component={ProfileDetails}
          />
          <PrivateRoute path="/downloads" exact component={Downloads} />
          <PrivateRoute path="/password" exact component={ChangePassword} />
          <PrivateRoute path="/onlineclass" exact component={OnlineClass} />
          <PrivateRoute
            path="/addonlineclass"
            exact
            component={AddOnlineClass}
          />
          <PrivateRoute path="/gallery" exact component={Gallery} />
          <PrivateRoute path="/notifications" exact component={Notification} />
          <PrivateRoute
            path="/tnotifications"
            exact
            component={TNotification}
          />
          <PrivateRoute path="/timetable" exact component={Timetable} />
          <PrivateRoute
            path="/teachertimetable"
            exact
            component={TeacherTimetable}
          />
          <PrivateRoute path="/aboutUs" exact component={AboutUs} />
          <PrivateRoute path="/aboutSchool" exact component={AboutSchool} />
          <PrivateRoute path="/homeWork" exact component={HomeWork} />
          <PrivateRoute path="/prevComplaint" exact component={Previous} />
          <PrivateRoute path="/newComplaint" exact component={New} />
          <PrivateRoute path="/prevLeave" exact component={PreviousLeave} />
          <PrivateRoute path="/newLeave" exact component={NewLeave} />
          <PrivateRoute path="/payments" exact component={Payments} />
          <PrivateRoute path="/feePayment" exact component={FeePayment} />
          <PrivateRoute path="/events" exact component={Events} />
          <PrivateRoute path="/holidays" exact component={Holidays} />
          <PrivateRoute path="/attendance" exact component={Attendance} />
          <PrivateRoute path="/attendancep" exact component={Attendancep} />
          <PrivateRoute path="/attStudent" exact component={AttStudent} />
          <PrivateRoute path="/attStaff" exact component={AttStaff} />
          <PrivateRoute path="/birthday" exact component={Birthday} />
          <PrivateRoute path="/allComplaint" exact component={AllComplaints} />
          <PrivateRoute path="/dashboard" exact component={Dashboard} />
          <PrivateRoute path="/maindashboard" exact component={MainDashboard} />
          <PrivateRoute path="/liveClass" exact component={LiveClass} />
          <PrivateRoute path="/termWiseFee" exact component={TermWise} />
          <PrivateRoute path="/classWiseFee" exact component={ClassWise} />
          <PrivateRoute path="/attSummary" exact component={AttSummary} />
          <PrivateRoute
            path="/uploadHomework"
            exact
            component={UploadHomeWork}
          />
          <PrivateRoute
            path="/AssignedHomework"
            exact
            component={AssignedHomeWork}
          />
          <PrivateRoute
            path="/markAtt/:classs/:classname/:section/:sectionname/:date"
            exact
            component={MarkAtt}
          />
          <PrivateRoute
            path="/viewAtt/:classs/:classname/:section/:sectionname/:date"
            exact
            component={ViewAtt}
          />
          <PrivateRoute path="/results" exact component={Results} />
          <PrivateRoute path="/grpsms" exact component={GroupSMS} />
          <PrivateRoute path="/classsms" exact component={ClassSMS} />
          <PrivateRoute path="/studentsms" exact component={StudentSms} />
          <PrivateRoute path="/staffsms" exact component={StaffSMS} />
          <PrivateRoute path="/numbersms" exact component={NumberSMS} />
          {/* <PrivateRoute path="/bus-tracking" exact component={LiveBusStatus} /> */}
          <PrivateRoute path="/smstemplate" exact component={SMSTemplate} />
          <PrivateRoute path="/examSchedule" exact component={ExamSchedule} />
          {/* <Route path="/login" exact component={Login} /> */}
          <Route path="/login" exact component={LoginV2} />
          <Route path="/fee-payment" exact component={PublicFeePayment} />
          <Route path="/forgotpassword" exact component={ForgotPassword} />
          <Route path="/thankyou" exact component={ThankYou} />
          <Route path="/failure" exact component={Failure} />
          <Route path="/results" exact component={Results} />
          <Route path="/exams" exact component={ExamSchedule} />
          <Route
            path="/examScheduledetail/:Id"
            exact
            component={ExamScheduleDetails}
          />
          <Route path="/addmarks" exact component={AddMarks} />
          <Route
            path="/addmarkstype/:classs/:classname/:section/:sectionname/"
            exact
            component={AddMarksType}
          />
          <Route
            path="/addmarksnew/:classs/:classname/:section/:sectionname/:typeid/:typename"
            exact
            component={AddMarksComponent}
          />
          <Route
            path="/addstudentsmarks/:class/:classname/:section/:sectionname/:typeid/:typename/:subjectid/:subjectId"
            exact
            component={AddMarksForStudents}
          />
          <PrivateRoute
            path="/exam-questions"
            exact
            component={ExamQuestions}
          />
          <Redirect to="/" />
        </Switch>
        {user.id && pathname !== "/profilePic" ? (
          <div>
            <div style={{ height: 56 }} />
            <FooterV2 />
          </div>
        ) : null}
        {/* {pathname === "/profilePic" ? null : <FooterV2 />} */}
      </Router>
    </div>
  );
};

export default connect(mapStateToProps)(App);
